'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Locale constants
 *
 * @module universal-locale-utils/locales
 */
/**
 * Supported locales this application supports
 * As much as possible, locale config should be based on this configuration.
 * Ordering rules are:
 *   1. English at the top (this is the vast majority of our user-base)
 *   2. Languages with non-ideographic labels, order by spelling of label
 *   3. Languages with ideographic labels, place at the end, ordered code
 *
 * @type {Object[]} configs
 * @type {Object}   config
 * @type {String}   config.code
 * @type {String}   config.value
 * @type {String}   config.label
 * @type {String}   config.hreflang
 * @type {String?}  config.intlPolyDataName - see `src/client/util/locale`
 * @type {String?}  config.contentfulLocale - see  `src/server/controllers/contentful`
 * @type {Boolean} config.hidden
 */
var locales = [{ code: 'en-US', value: '', label: 'English', hreflang: 'en', hidden: false },
{ code: 'en-GB', value: 'en-GB', label: 'English (GB)', hreflang: 'en-GB', hidden: false }, { code: 'en-ZA', value: 'en-ZA', label: 'English (ZA)', hreflang: 'en-ZA', hidden: false }, { code: 'ar-AE', value: 'ar-AE', label: 'العَرَبِيَّة‎', hreflang: 'ar-AE', hidden: true }, { code: 'id-ID', value: 'id-ID', label: 'Bahasa Indonesia', hreflang: 'id-ID', hidden: false }, { code: 'ms-MY', value: 'ms-MY', label: 'Bahasa Melayu', hreflang: 'ms-MY', hidden: false }, { code: 'ca-ES', value: 'ca-ES', label: 'Català', hreflang: 'ca-ES', hidden: false }, { code: 'cs-CZ', value: 'cs-CZ', label: 'Čeština', hreflang: 'cs-CZ', hidden: false }, { code: 'da-DK', value: 'da-DK', label: 'Dansk', hreflang: 'da-DK', hidden: false }, { code: 'de-DE', value: 'de-DE', label: 'Deutsch', hreflang: 'de', hidden: false }, { code: 'es-ES', value: 'es-ES', label: 'Español (ES)', hreflang: 'es-ES', hidden: false }, { code: 'es-LA', value: 'es-LA', label: 'Español (LA)', hreflang: 'es-LA', intlPolyDataName: 'es-419', contentfulLocale: 'es-419', hidden: false }, { code: 'fr-FR', value: 'fr-FR', label: 'Français', hreflang: 'fr', hidden: false }, { code: 'fr-CA', value: 'fr-CA', label: 'Français (CA)', hreflang: 'fr-CA', hidden: false }, { code: 'it-IT', value: 'it-IT', label: 'Italiano', hreflang: 'it-IT', hidden: false }, { code: 'nl-NL', value: 'nl-NL', label: 'Nederlands', hreflang: 'nl', hidden: false }, { code: 'nb-NO', value: 'nb-NO', label: 'Norsk', hreflang: 'nb-NO', hidden: false }, { code: 'pl-PL', value: 'pl-PL', label: 'Polski', hreflang: 'pl-PL', hidden: false }, { code: 'pt-BR', value: 'pt-BR', label: 'Português (BR)', hreflang: 'pt-BR', hidden: false }, { code: 'pt-PT', value: 'pt-PT', label: 'Português (PT)', hreflang: 'pt-PT', hidden: false }, { code: 'ru-RU', value: 'ru-RU', label: 'Pусский', hreflang: 'ru-RU', hidden: false }, { code: 'fi-FI', value: 'fi-FI', label: 'Suomi', hreflang: 'fi-FI', hidden: false }, { code: 'sv-SE', value: 'sv-SE', label: 'Svenska', hreflang: 'sv-SE', hidden: false }, { code: 'ja-JP', value: 'ja-JP', label: '日本語', hreflang: 'ja-JP', hidden: false }, { code: 'ko-KR', value: 'ko-KR', label: '한국어', hreflang: 'ko', hidden: false }, { code: 'th-TH', value: 'th-TH', label: 'ไทย', hreflang: 'th-TH', hidden: false }, { code: 'vi-VN', value: 'vi-VN', label: 'Tiếng Việt', hreflang: 'vi-VN', hidden: false }, { code: 'zh-CN', value: 'zh-CN', label: '中文 (简体)', hreflang: 'zh', intlPolyDataName: 'zh-Hans-CN', hidden: false }, { code: 'zh-TW', value: 'zh-TW', label: '中文 (繁體)', hreflang: 'zh-TW', intlPolyDataName: 'zh-Hant-TW', contentfulLocale: 'zh-Hant-TW', hidden: false }];

/**
 * Country constants
 *
 * @module universal-locale-utils/countries
 *
 * ISO 2-Letter Country Codes - https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
 */
/**
 * Country Codes
 * @type {Object}
 */
var COUNTRY_CODES = {
  Australia: 'AU',
  Brazil: 'BR',
  Canada: 'CA',
  China: 'CN',
  CzechRepublic: 'CZ',
  Denmark: 'DK',
  Finland: 'FI',
  France: 'FR',
  Germany: 'DE',
  India: 'IN',
  Indonesia: 'ID',
  Israel: 'IL',
  Italy: 'IT',
  Japan: 'JP',
  Korea: 'KR',
  LatinAmerica: 'LA',
  Malaysia: 'MY',
  Netherlands: 'NL',
  Norway: 'NO',
  Poland: 'PL',
  Portugal: 'PT',
  Russia: 'RU',
  SouthAfrica: 'ZA',
  Spain: 'ES',
  Sweden: 'SE',
  Thailand: 'TH',
  UnitedArabEmirates: 'AE',
  UnitedKingdom: 'GB',
  UnitedStates: 'US',
  Vietnam: 'VN'
};
/**
 * European Country Codes
 * @type {String[]}
 */
var EU_COUNTRY_CODES = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'];
/**
 * Additional Countries that are
 * not part of the EU, but we need
 * display Cookie Consent for
 * @type {String[]}
 */
var ADDITIONAL_COOKIE_COUNTRIES = ['IS',
'LI',
'NO'];

/**
 * Locale definitions and utils
 *
 * @module universal-locale-utils
 */
/**
 * Locale definitions. See `src/locales`.
 * @type {Object[]}
 */
var LOCALE_DEFINITIONS = locales;
/**
 * Visible Locale definitions. See `src/locales`.
 * @type {Object[]}
 */
var VISIBLE_LOCALE_DEFINITIONS = locales.filter(function (locale) {
  return !locale.hidden;
});
/**
 * Country definitions. See `src/countries`.
 * @type {Object}
 */
var COUNTRY_DEFINITIONS = { EU_COUNTRY_CODES: EU_COUNTRY_CODES, COUNTRY_CODES: COUNTRY_CODES };
/**
 * Validates simple IETF language tags
 * https://en.wikipedia.org/wiki/IETF_language_tag
 * Note: does not handle complex codes like
 * `zh-Hant-TW` but does accept `zh-TW`
 * @type {RegExp}
 */
var validLocaleRE = /^[a-z]{2}-[A-Z]{2}$/;
/**
 * The default locale code.
 * @type {String} = "en-US"
 */
var DEFAULT_LOCALE = locales[0].code;
/**
 * All supported locale codes
 * @type {String[]}
 */
var SUPPORTED_LOCALES = locales.map(function (localeDef) {
  return localeDef.code;
});
var localeDelimitersRE = /-|_/;
/**
 * Is this locale the default locale?
 * @param  {String} locale
 * @return {Boolean}
 */
var isEN = function isEN() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return locale.toLowerCase() === DEFAULT_LOCALE.toLowerCase();
};
/**
 * Get the language code from a simple IETF locale code
 * @param  {String} locale "fr-CA"
 * @return {String} "fr"
 */
function localeToLang() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_LOCALE;
  return locale.split(localeDelimitersRE)[0];
}
/**
 * Get the country code from a simple IETF locale code
 * @param  {String} locale "fr-CA"
 * @return {String} "CA"
 */
function localeToCountry() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_LOCALE;
  return locale.split(localeDelimitersRE)[1];
}
/**
 * Helper to format a locale code correctly for a
 * Facebook OG tag
 * @param  {String} locale "en-US"
 * @return {String} "en_US"
 */
function localeToOGLocale() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_LOCALE;
  return locale.replace(localeDelimitersRE, '_');
}
/**
 * Utility to deep the default locale out of strings.
 * Especially handy when generating links.
 *
 * Takes a locale string and returns '' if it is "en-US"
 * or "/locale" otherwise
 *
 * @example
 * fetch(`http://some.api${maybeLocale('en-US')}/path/${param}`)
 *
 * @param  {String} locale
 * @return {String}
 */
var maybeLocale = function maybeLocale() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!locale || isEN(locale)) {
    return '';
  }
  return '/' + locale;
};
/**
 * Assembles hreflang url based on siteUrl, lang, and path
 * @param  {String} siteUrl
 * @param  {String} path
 * @param  {String} lang
 * @return {String}
 */
var hreflang = function hreflang(siteUrl, path, lang) {
  var hreflangPath = '';
  if (path) {
    hreflangPath = path[0] === '/' ? path : '/' + path;
  }
  return '' + siteUrl + maybeLocale(lang) + hreflangPath;
};
/**
 * Assembles a regex for checking if a url path includes a locale
 * @param  {String} locale
 * @return {RegExp}
 */
var pathRegexForLocale = function pathRegexForLocale() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_LOCALE;
  return new RegExp('/' + locale + '/?');
};
/**
 * Checks if a locale is valid and supported
 * @param  {String} locale
 * @return {Boolean}
 */
var isSupportedLocale = function isSupportedLocale() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return validLocaleRE.test(locale) && SUPPORTED_LOCALES.includes(locale);
};
/**
 * Checks if countries match
 * @param  {String}  countryCode "US"
 * @param  {String}  compareCode "CA"
 * @return {Boolean}
 */
function isRequestFromCountry() {
  var countryCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : localeToCountry(DEFAULT_LOCALE);
  var compareCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return countryCode.toUpperCase() === compareCode.toUpperCase();
}
/**
 * Checks if a country code is a European country
 * @param  {String}  countryCode
 * @return {Boolean}
 */
function isRequestFromEUCountry() {
  var countryCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return EU_COUNTRY_CODES.includes(countryCode.toUpperCase());
}
/**
 * Checks if country code is China
 * @param  {String}  countryCode
 * @return {Boolean}
 */
function isRequestFromChina() {
  var countryCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return isRequestFromCountry(countryCode, COUNTRY_CODES.China);
}
/**
 * Checks if a country code is US
 * @param  {String}  countryCode
 * @return {Boolean}
 */
function isRequestFromUS() {
  var countryCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return isRequestFromCountry(countryCode, COUNTRY_CODES.UnitedStates);
}
/**
 * Checks if country is regulated by GDPR
 * @param {String} countryCode
 * @return {Boolean}
 */
function isCountryRegulatedByGDPR() {
  var countryCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var countryCodeUpperCase = countryCode.toUpperCase();
  return isRequestFromEUCountry(countryCodeUpperCase) || ADDITIONAL_COOKIE_COUNTRIES.includes(countryCodeUpperCase);
}

exports.LOCALE_DEFINITIONS = LOCALE_DEFINITIONS;
exports.VISIBLE_LOCALE_DEFINITIONS = VISIBLE_LOCALE_DEFINITIONS;
exports.COUNTRY_DEFINITIONS = COUNTRY_DEFINITIONS;
exports.validLocaleRE = validLocaleRE;
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
exports.SUPPORTED_LOCALES = SUPPORTED_LOCALES;
exports.localeDelimitersRE = localeDelimitersRE;
exports.isEN = isEN;
exports.localeToLang = localeToLang;
exports.localeToCountry = localeToCountry;
exports.localeToOGLocale = localeToOGLocale;
exports.maybeLocale = maybeLocale;
exports.hreflang = hreflang;
exports.pathRegexForLocale = pathRegexForLocale;
exports.isSupportedLocale = isSupportedLocale;
exports.isRequestFromCountry = isRequestFromCountry;
exports.isRequestFromEUCountry = isRequestFromEUCountry;
exports.isRequestFromChina = isRequestFromChina;
exports.isRequestFromUS = isRequestFromUS;
exports.isCountryRegulatedByGDPR = isCountryRegulatedByGDPR;
//# sourceMappingURL=index.js.map
